import { BaseFeature, FeatureType } from '@core/shared/feature';
export class AuthStrategyCredentialsBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/auth-strategy-credentials/feature","featureId":"common-auth-strategy-credentials"},
      bundledItemModels: ["UserActivationCodeItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users', 'common-mail'],
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'AuthStrategyCredentialsFrontendFeature'
      },
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'AuthStrategyCredentialsFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'AuthStrategyCredentialsFrontendFeature',
        importFrom: 'frontend'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'AuthStrategyCredentialsFrontendAdminFeature',
        importFrom: 'frontend-admin'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'AuthStrategyCredentialsBackendFeature',
        moduleFactory: 'forRoot'
      }
      // {forPlatform:'backend-admin', type:FeatureType.Permanent, pluginClassName:'AuthStrategyCredentialsBackendAdminFeature'},
      ]
    };
  }
  getSharedDefinition() {
    const frontendRouterLinkResolvers = {
      'reset-password': () => '/auth/credentials/reset-password'
    };
    return {
      routerLinkResolvers: {
        frontend: frontendRouterLinkResolvers
      }
    };
  }
}